export default class ExcelExporter {
    constructor() {
      // Initialize
    }

    formatNum(val) {
        if (val === null || val === undefined) {
            return 0;
        }
        
        /*
        let cleanVal = typeof val === 'string' ? val.replace(',', '') : val;
        let cleanVal2 = typeof cleanVal === 'string' ? cleanVal.replace('.', ',') : cleanVal;
        //let cleanVal = typeof val === 'string' ? val.toLocaleString('en-US', { style: 'currency', currency: 'USD' }) : val;
        //console.log(`val: ${val} - ${cleanVal} - ${cleanVal2}` );
        return cleanVal2; //parseFloat(cleanVal) || 0;
        */

        // Ubah angka menjadi string
        let formattedNumber = val.toString();

        // Temukan posisi titik desimal
        let decimalPointIndex = formattedNumber.indexOf('.');

        // Ganti titik desimal dengan koma jika ada
        if (decimalPointIndex !== -1) {
            formattedNumber = formattedNumber.slice(0, decimalPointIndex) + ',' + formattedNumber.slice(decimalPointIndex + 1);
        }

        return formattedNumber;
        
    }

    formatNum2(val) {
        //console.log('val 2: ' + val);
        if (val === null || val === undefined) {
            return 0;
        }
        
        /*
        let val2 = val.toLocaleString(); 
        let cleanVal = val2.replace(',', '');
        let cleanVal2 = cleanVal.replace('.', ',');
        //let cleanVal = typeof val === 'string' ? val.toLocaleString('en-US', { style: 'currency', currency: 'USD' }) : val;
        //console.log(`val: ${val} - ${cleanVal} - ${cleanVal2}` );
        return cleanVal2 || 0;
        */

        // Ubah angka menjadi string
        let formattedNumber = val.toString();

        // Temukan posisi titik desimal
        let decimalPointIndex = formattedNumber.indexOf('.');

        // Ganti titik desimal dengan koma jika ada
        if (decimalPointIndex !== -1) {
            formattedNumber = formattedNumber.slice(0, decimalPointIndex) + ',' + formattedNumber.slice(decimalPointIndex + 1);
        }

        return formattedNumber;
        
    }
  
    // Standard HTML
    exportBrightToHTML(tableData, filename, totals, averages) {
      let htmlContent = `
        <html>
        <head>
          <style>
            table {
                width: 100%;
                border-collapse: collapse;
                table-layout: fixed;
            }
            th, td {
                border: 1px solid black;
                padding: 8px;
            }
            th {
                background-color: #f2f2f2;
                text-align: center;
            }
            .highlight {
                background-color: #ffeb3b;
            }    
            text-right {
                text-align: right;
            }
            .bg-ps-orange1 {
                background: #F1A983;
                color: #000000;
            }

            .bg-ps-green {
                background: #8ED973;
                color: #000000;
            }

            .bg-ps-orange2 {
                background: #FFC000;
                color: #000000;
            }

            .bg-ps-grey {
                background: #BFBFBF;
                color: #000000;
            }

            .bg-ps-pink {
                background: #E49EDD;
                color: #000000;
            }

          </style>
        </head>
        <body>
            <table>
                <thead>
                    <tr>
                        <th rowspan="2" style="background: #edf2f7;z-index:3;">Unit/Lokasi</th>
                        <th colspan="4" class="bg-ps-orange1">Sales</th>
                        <th colspan="3" class="bg-ps-orange2">COGS</th>
                        <th colspan="4" class="bg-ps-green">Gross Margin</th>
                        <th colspan="3" class="bg-ps-orange2">Opex</th>
                        <th colspan="3" class="bg-ps-grey">Depresiasi</th>
                        <th colspan="3" class="bg-ps-pink">Earning After Tax</th>
                        <th colspan="4" class="bg-ps-orange1">Service Level</th>
                    </tr>
                    <tr>
                        <th class="bg-ps-orange1" style="z-index: 1; border-radius:0px;">FS Sales</th>
                        <th class="bg-ps-orange1">Realisasi</th>
                        <th class="bg-ps-orange1">% Real</th>
                        <th class="bg-ps-orange1">SPD</th>

                        <th class="bg-ps-orange2">FS COGS</th>
                        <th class="bg-ps-orange2">Realisasi</th>
                        <th class="bg-ps-orange2">% Real</th>

                        <th class="bg-ps-green">FS GM</th>
                        <th class="bg-ps-green">Realisasi</th>
                        <th class="bg-ps-green">% Real</th>
                        <th class="bg-ps-green">GPM</th>

                        <th class="bg-ps-orange2">FS Opex</th>
                        <th class="bg-ps-orange2">Realisasi</th>
                        <th class="bg-ps-orange2">% Real</th>

                        <th class="bg-ps-grey">FS Depresiasi</th>
                        <th class="bg-ps-grey">Realisasi</th>
                        <th class="bg-ps-grey">% Real</th>

                        <th class="bg-ps-pink">FS EAT</th>
                        <th class="bg-ps-pink">Realisasi</th>
                        <th class="bg-ps-pink" style="border-radius: 0px">% Real</th>

                        <th class="bg-ps-orange1">To Branch</th>
                        <th class="bg-ps-orange1">PB Qty</th>
                        <th class="bg-ps-orange1">Trans Qty</th>
                        <th class="bg-ps-orange1" style="border-radius: 0px">% Complete Order</th>
                    </tr>
                </thead>
            <tbody>
      `;
  
      tableData.forEach(item => {
            htmlContent += `
                <tr>
                    <td>${ item?.UnitName }</td>

                    <td class="text-right">${ this.formatNum(item?.FSSales) }</td>
                    <td class="text-right">${ this.formatNum(item?.SalesRealisasi) }</td>
                    <td class="text-right">${ this.formatNum(item?.SalesRealisasiPercentage) }</td>
                    <td class="text-right">${ this.formatNum(item?.SPD) }</td>

                    <td class="text-right">${ this.formatNum(item?.FSCogs) }</td>
                    <td class="text-right">${ this.formatNum(item?.Cogs) }</td>
                    <td class="text-right">${ this.formatNum(item?.CogsRealisasiPercentage) }</td>

                    <td class="text-right">${ this.formatNum(item?.FSGM) }</td>
                    <td class="text-right">${ this.formatNum(item?.GrossProfitRealisasi) }</td>
                    <td class="text-right">${ this.formatNum(item?.GrossProfitRealisasiPercentage) }</td>
                    <td class="text-right">${ this.formatNum(item?.GPM) }</td>

                    <td class="text-right">${ this.formatNum(item?.FSOpex) }</td>
                    <td class="text-right">${ this.formatNum(item?.OpexRealisasi) }</td>
                    <td class="text-right">${ this.formatNum(item?.OpexRealisasiPercentage) }</td>

                    <td class="text-right">${ this.formatNum(item?.FSDepresiasi) }</td>
                    <td class="text-right">${ this.formatNum(item?.DepresiasiRealisasi) }</td>
                    <td class="text-right">${ this.formatNum(item?.DepresiasiRealisasiPercentage) }</td>

                    <td class="text-right">${ this.formatNum(item?.FSEAT) }</td>
                    <td class="text-right">${ this.formatNum(item?.EatRealisasi) }</td>
                    <td class="text-right">${ this.formatNum(item?.EatRealisasiPercentage) }</td>

                    <td class="text-right">${ item?.ToBranchName }</td>
                    <td class="text-right">${ this.formatNum(item?.PBQty) }</td>
                    <td class="text-right">${ this.formatNum(item?.TransQty) }</td>
                    <td class="text-right">${ this.formatNum(item?.CompleteOrderinPercentage) }</td>
                </tr>
            `;
        });
  
        htmlContent += `
            </tbody>
            <tfoot>`;

        htmlContent += `
            <tr>
                <td>AVERAGE</td>

                <td class="text-right">${ this.formatNum2(averages?.FSSales) }</td>
                <td class="text-right">${ this.formatNum(averages?.SalesRealisasi) }</td>
                <td class="text-right">${ this.formatNum(averages?.SalesRealisasiPercentage) }</td>
                <td class="text-right">${ this.formatNum(averages?.SPD) }</td>

                <td class="text-right">${ this.formatNum(averages?.FSCogs) }</td>
                <td class="text-right">${ this.formatNum(averages?.Cogs) }</td>
                <td class="text-right">${ this.formatNum(averages?.CogsRealisasiPercentage) }</td>

                <td class="text-right">${ this.formatNum(averages?.FSGM) }</td>
                <td class="text-right">${ this.formatNum(averages?.GrossProfitRealisasi) }</td>
                <td class="text-right">${ this.formatNum(averages?.GrossProfitRealisasiPercentage) }</td>
                <td class="text-right">${ this.formatNum(averages?.GPM) }</td>

                <td class="text-right">${ this.formatNum(averages?.FSOpex) }</td>
                <td class="text-right">${ this.formatNum(averages?.OpexRealisasi) }</td>
                <td class="text-right">${ this.formatNum(averages?.OpexRealisasiPercentage) }</td>

                <td class="text-right">${ this.formatNum(averages?.FSDepresiasi) }</td>
                <td class="text-right">${ this.formatNum(averages?.DepresiasiRealisasi) }</td>
                <td class="text-right">${ this.formatNum(averages?.DepresiasiRealisasiPercentage) }</td>

                <td class="text-right">${ this.formatNum(averages?.FSEAT) }</td>
                <td class="text-right">${ this.formatNum(averages?.EatRealisasi) }</td>
                <td class="text-right">${ this.formatNum(averages?.EatRealisasiPercentage) }</td>

                <td class="text-right"></td>
                <td class="text-right">${ this.formatNum(averages?.PBQty) }</td>
                <td class="text-right">${ this.formatNum(averages?.TransQty) }</td>
                <td class="text-right">${ this.formatNum(averages?.CompleteOrderinPercentage) }</td>
            </tr>
        `;

        htmlContent += `
            <tr>
                <td>TOTAL</td>

                <td class="text-right">${ this.formatNum2(totals?.FSSales) }</td>
                <td class="text-right">${ this.formatNum(totals?.SalesRealisasi) }</td>
                <td class="text-right">${ this.formatNum(totals?.SalesRealisasiPercentage) }</td>
                <td class="text-right">${ this.formatNum(totals?.SPD) }</td>

                <td class="text-right">${ this.formatNum(totals?.FSCogs) }</td>
                <td class="text-right">${ this.formatNum(totals?.Cogs) }</td>
                <td class="text-right">${ this.formatNum(totals?.CogsRealisasiPercentage) }</td>

                <td class="text-right">${ this.formatNum(totals?.FSGM) }</td>
                <td class="text-right">${ this.formatNum(totals?.GrossProfitRealisasi) }</td>
                <td class="text-right">${ this.formatNum(totals?.GrossProfitRealisasiPercentage) }</td>
                <td class="text-right">${ this.formatNum(totals?.GPM) }</td>

                <td class="text-right">${ this.formatNum(totals?.FSOpex) }</td>
                <td class="text-right">${ this.formatNum(totals?.OpexRealisasi) }</td>
                <td class="text-right">${ this.formatNum(totals?.OpexRealisasiPercentage) }</td>

                <td class="text-right">${ this.formatNum(totals?.FSDepresiasi) }</td>
                <td class="text-right">${ this.formatNum(totals?.DepresiasiRealisasi) }</td>
                <td class="text-right">${ this.formatNum(totals?.DepresiasiRealisasiPercentage) }</td>

                <td class="text-right">${ this.formatNum(totals?.FSEAT) }</td>
                <td class="text-right">${ this.formatNum(totals?.EatRealisasi) }</td>
                <td class="text-right">${ this.formatNum(totals?.EatRealisasiPercentage) }</td>

                <td class="text-right"></td>
                <td class="text-right">${ this.formatNum(totals?.PBQty) }</td>
                <td class="text-right">${ this.formatNum(totals?.TransQty) }</td>
                <td class="text-right">${ this.formatNum(totals?.CompleteOrderinPercentage) }</td>
            </tr>
        `;
        
        htmlContent += `
            </tfoot>
          </table>
        </body>
        </html>
        `;
  
      this.downloadFile(htmlContent, filename+'.xls');
    }
  
    exportFuelToHTML(tableData, filename, totals, averages) {
      let htmlContent = `
        <html>
        <head>
          <style>
            table {
                width: 100%;
                border-collapse: collapse;
                table-layout: fixed;
            }
            th, td {
                border: 1px solid black;
                padding: 8px;
            }
            th {
                background-color: #f2f2f2;
                text-align: center;
            }
            .highlight {
                background-color: #ffeb3b;
            }    
            text-right {
                text-align: right;
            }
            .bg-ps-orange1 {
                background: #F1A983;
                color: #000000;
            }

            .bg-ps-green {
                background: #8ED973;
                color: #000000;
            }

            .bg-ps-orange2 {
                background: #FFC000;
                color: #000000;
            }

            .bg-ps-grey {
                background: #BFBFBF;
                color: #000000;
            }

            .bg-ps-pink {
                background: #E49EDD;
                color: #000000;
            }
          </style>
        </head>
        <body>
            <table>
                <thead>
                    <tr>
                        <th rowspan="2" style="background: #edf2f7;z-index:3;">Unit/Lokasi</th>
                        <th colspan="3" class="bg-ps-orange1">Sales Volume KL/Day</th>
                        <th colspan="3" class="bg-ps-green">Gross Margin</th>
                        <th colspan="3" class="bg-ps-orange2">Opex</th>
                        <th colspan="3" class="bg-ps-grey">Depresiasi</th>
                        <th colspan="3" class="bg-ps-pink">Earning After Tax</th>
                    </tr>
                    <tr>
                        <th class="bg-ps-orange1" style="z-index: 1; border-radius:0px;">FS Sales</th>
                        <th class="bg-ps-orange1">Realisasi</th>
                        <th class="bg-ps-orange1">% Real</th>

                        <th class="bg-ps-green">FS GM</th>
                        <th class="bg-ps-green">Realisasi</th>
                        <th class="bg-ps-green">% Real</th>

                        <th class="bg-ps-orange2">FS Opex</th>
                        <th class="bg-ps-orange2">Realisasi</th>
                        <th class="bg-ps-orange2">% Real</th>

                        <th class="bg-ps-grey">FS Depresiasi</th>
                        <th class="bg-ps-grey">Realisasi</th>
                        <th class="bg-ps-grey">% Real</th>

                        <th class="bg-ps-pink">FS EAT</th>
                        <th class="bg-ps-pink">Realisasi</th>
                        <th class="bg-ps-pink" style="border-radius: 0px">% Real</th>
                    </tr>
                </thead>
            <tbody>
      `;
  
      tableData.forEach(item => {
        htmlContent += `
            <tr>
                <td>${ item?.UnitName }</td>

                <td class="text-right">${ this.formatNum(item?.FSSales) }</td>
                <td class="text-right">${ this.formatNum(item?.SalesRealisasi) }</td>
                <td class="text-right">${ this.formatNum(item?.SalesRealisasiPercentage) }</td>

                <td class="text-right">${ this.formatNum(item?.FSGM) }</td>
                <td class="text-right">${ this.formatNum(item?.GrossProfitRealisasi) }</td>
                <td class="text-right">${ this.formatNum(item?.GrossProfitRealisasiPercentage) }</td>

                <td class="text-right">${ this.formatNum(item?.FSOpex) }</td>
                <td class="text-right">${ this.formatNum(item?.OpexRealisasi) }</td>
                <td class="text-right">${ this.formatNum(item?.OpexRealisasiPercentage) }</td>

                <td class="text-right">${ this.formatNum(item?.FSDepresiasi) }</td>
                <td class="text-right">${ this.formatNum(item?.DepresiasiRealisasi) }</td>
                <td class="text-right">${ this.formatNum(item?.DepresiasiRealisasiPercentage) }</td>

                <td class="text-right">${ this.formatNum(item?.FSEAT) }</td>
                <td class="text-right">${ this.formatNum(item?.EatRealisasi) }</td>
                <td class="text-right">${ this.formatNum(item?.EatRealisasiPercentage) }</td>
            </tr>
            `;
        });
  
        htmlContent += `
            </tbody>
            <tfoot> `;

        htmlContent += `
            <tr>
                <td>AVERAGE</td>

                <td class="text-right">${ this.formatNum(averages?.FSSales) }</td>
                <td class="text-right">${ this.formatNum(averages?.SalesRealisasi) }</td>
                <td class="text-right">${ this.formatNum(averages?.SalesRealisasiPercentage) }</td>

                <td class="text-right">${ this.formatNum(averages?.FSGM) }</td>
                <td class="text-right">${ this.formatNum(averages?.GrossProfitRealisasi) }</td>
                <td class="text-right">${ this.formatNum(averages?.GrossProfitRealisasiPercentage) }</td>

                <td class="text-right">${ this.formatNum(averages?.FSOpex) }</td>
                <td class="text-right">${ this.formatNum(averages?.OpexRealisasi) }</td>
                <td class="text-right">${ this.formatNum(averages?.OpexRealisasiPercentage) }</td>

                <td class="text-right">${ this.formatNum(averages?.FSDepresiasi) }</td>
                <td class="text-right">${ this.formatNum(averages?.DepresiasiRealisasi) }</td>
                <td class="text-right">${ this.formatNum(averages?.DepresiasiRealisasiPercentage) }</td>

                <td class="text-right">${ this.formatNum(averages?.FSEAT) }</td>
                <td class="text-right">${ this.formatNum(averages?.EatRealisasi) }</td>
                <td class="text-right">${ this.formatNum(averages?.EatRealisasiPercentage) }</td>
            </tr>
        `;

        htmlContent += `
            <tr>
                <td>TOTAL</td>

                <td class="text-right">${ this.formatNum(totals?.FSSales) }</td>
                <td class="text-right">${ this.formatNum(totals?.SalesRealisasi) }</td>
                <td class="text-right">${ this.formatNum(totals?.SalesRealisasiPercentage) }</td>

                <td class="text-right">${ this.formatNum(totals?.FSGM) }</td>
                <td class="text-right">${ this.formatNum(totals?.GrossProfitRealisasi) }</td>
                <td class="text-right">${ this.formatNum(totals?.GrossProfitRealisasiPercentage) }</td>

                <td class="text-right">${ this.formatNum(totals?.FSOpex) }</td>
                <td class="text-right">${ this.formatNum(totals?.OpexRealisasi) }</td>
                <td class="text-right">${ this.formatNum(totals?.OpexRealisasiPercentage) }</td>

                <td class="text-right">${ this.formatNum(totals?.FSDepresiasi) }</td>
                <td class="text-right">${ this.formatNum(totals?.DepresiasiRealisasi) }</td>
                <td class="text-right">${ this.formatNum(totals?.DepresiasiRealisasiPercentage) }</td>

                <td class="text-right">${ this.formatNum(totals?.FSEAT) }</td>
                <td class="text-right">${ this.formatNum(totals?.EatRealisasi) }</td>
                <td class="text-right">${ this.formatNum(totals?.EatRealisasiPercentage) }</td>
            </tr>
        `;

        htmlContent += `
            </tfoot>
          </table>
        </body>
        </html>
      `;
  
      this.downloadFile(htmlContent, filename+'.xls');
    }

    exportLpgToHTML(tableData, filename, totals, averages) {
        let htmlContent = `
          <html>
          <head>
            <style>
              table {
                  width: 100%;
                  border-collapse: collapse;
                  table-layout: fixed;
              }
              th, td {
                  border: 1px solid black;
                  padding: 8px;
              }
              th {
                  background-color: #f2f2f2;
                  text-align: center;
              }
              .highlight {
                  background-color: #ffeb3b;
              }    
              text-right {
                  text-align: right;
              }
              .bg-ps-orange1 {
                  background: #F1A983;
                  color: #000000;
              }
  
              .bg-ps-green {
                  background: #8ED973;
                  color: #000000;
              }
  
              .bg-ps-orange2 {
                  background: #FFC000;
                  color: #000000;
              }
  
              .bg-ps-grey {
                  background: #BFBFBF;
                  color: #000000;
              }
  
              .bg-ps-pink {
                  background: #E49EDD;
                  color: #000000;
              }
            </style>
          </head>
          <body>
              <table>
                  <thead>
                      <tr>
                          <th rowspan="2" style="background: #edf2f7;z-index:3;">Unit/Lokasi</th>
                          <th colspan="4" class="bg-ps-orange1">Sales</th>
                          <th colspan="3" class="bg-ps-orange2">COGS</th>
                          <th colspan="3" class="bg-ps-green">Gross Margin</th>
                          <th colspan="3" class="bg-ps-orange2">Opex</th>
                          <th colspan="3" class="bg-ps-grey">Depresiasi</th>
                          <th colspan="3" class="bg-ps-pink">Earning After Tax</th>
                      </tr>
                      <tr>
                          <th class="bg-ps-orange1" style="z-index: 1; border-radius:0px;">FS Sales</th>
                          <th class="bg-ps-orange1">Realisasi</th>
                          <th class="bg-ps-orange1">% Real</th>
                          <th class="bg-ps-orange1">SPD</th>
  
                          <th class="bg-ps-orange2">FS COGS</th>
                          <th class="bg-ps-orange2">Realisasi</th>
                          <th class="bg-ps-orange2">% Real</th>
  
                          <th class="bg-ps-green">FS GM</th>
                          <th class="bg-ps-green">Realisasi</th>
                          <th class="bg-ps-green">% Real</th>
  
                          <th class="bg-ps-orange2">FS Opex</th>
                          <th class="bg-ps-orange2">Realisasi</th>
                          <th class="bg-ps-orange2">% Real</th>
  
                          <th class="bg-ps-grey">FS Depresiasi</th>
                          <th class="bg-ps-grey">Realisasi</th>
                          <th class="bg-ps-grey">% Real</th>
  
                          <th class="bg-ps-pink">FS EAT</th>
                          <th class="bg-ps-pink">Realisasi</th>
                          <th class="bg-ps-pink" style="border-radius: 0px">% Real</th>
                      </tr>
                  </thead>
              <tbody>
        `;
    
        tableData.forEach(item => {
          htmlContent += `
            <tr>
                      <td>${ item?.UnitName }</td>
  
                      <td class="text-right">${ this.formatNum(item?.FSSales) }</td>
                      <td class="text-right">${ this.formatNum(item?.SalesRealisasi) }</td>
                      <td class="text-right">${ this.formatNum(item?.SalesRealisasiPercentage) }</td>
                      <td class="text-right">${ this.formatNum(item?.SPD) }</td>
  
                      <td class="text-right">${ this.formatNum(item?.FSCogs) }</td>
                      <td class="text-right">${ this.formatNum(item?.Cogs) }</td>
                      <td class="text-right">${ this.formatNum(item?.CogsRealisasiPercentage) }</td>
  
                      <td class="text-right">${ this.formatNum(item?.FSGM) }</td>
                      <td class="text-right">${ this.formatNum(item?.GrossProfitRealisasi) }</td>
                      <td class="text-right">${ this.formatNum(item?.GrossProfitRealisasiPercentage) }</td>
  
                      <td class="text-right">${ this.formatNum(item?.FSOpex) }</td>
                      <td class="text-right">${ this.formatNum(item?.OpexRealisasi) }</td>
                      <td class="text-right">${ this.formatNum(item?.OpexRealisasiPercentage) }</td>
  
                      <td class="text-right">${ this.formatNum(item?.FSDepresiasi) }</td>
                      <td class="text-right">${ this.formatNum(item?.DepresiasiRealisasi) }</td>
                      <td class="text-right">${ this.formatNum(item?.DepresiasiRealisasiPercentage) }</td>
  
                      <td class="text-right">${ this.formatNum(item?.FSEAT) }</td>
                      <td class="text-right">${ this.formatNum(item?.EatRealisasi) }</td>
                      <td class="text-right">${ this.formatNum(item?.EatRealisasiPercentage) }</td>
  
                  </tr>
          `;
        });
    
        htmlContent += `</tbody>
                    <tfoot>`;
        
        htmlContent += `
                <tr>
                    <td>AVERAGE</td>

                    <td class="text-right">${ this.formatNum(averages?.FSSales) }</td>
                    <td class="text-right">${ this.formatNum(averages?.SalesRealisasi) }</td>
                    <td class="text-right">${ this.formatNum(averages?.SalesRealisasiPercentage) }</td>
                    <td class="text-right">${ this.formatNum(averages?.SPD) }</td>

                    <td class="text-right">${ this.formatNum(averages?.FSCogs) }</td>
                    <td class="text-right">${ this.formatNum(averages?.Cogs) }</td>
                    <td class="text-right">${ this.formatNum(averages?.CogsRealisasiPercentage) }</td>

                    <td class="text-right">${ this.formatNum(averages?.FSGM) }</td>
                    <td class="text-right">${ this.formatNum(averages?.GrossProfitRealisasi) }</td>
                    <td class="text-right">${ this.formatNum(averages?.GrossProfitRealisasiPercentage) }</td>

                    <td class="text-right">${ this.formatNum(averages?.FSOpex) }</td>
                    <td class="text-right">${ this.formatNum(averages?.OpexRealisasi) }</td>
                    <td class="text-right">${ this.formatNum(averages?.OpexRealisasiPercentage) }</td>

                    <td class="text-right">${ this.formatNum(averages?.FSDepresiasi) }</td>
                    <td class="text-right">${ this.formatNum(averages?.DepresiasiRealisasi) }</td>
                    <td class="text-right">${ this.formatNum(averages?.DepresiasiRealisasiPercentage) }</td>

                    <td class="text-right">${ this.formatNum(averages?.FSEAT) }</td>
                    <td class="text-right">${ this.formatNum(averages?.EatRealisasi) }</td>
                    <td class="text-right">${ this.formatNum(averages?.EatRealisasiPercentage) }</td>

                </tr>
        `;

        htmlContent += `
                <tr>
                    <td>TOTAL</td>

                    <td class="text-right">${ this.formatNum(totals?.FSSales) }</td>
                    <td class="text-right">${ this.formatNum(totals?.SalesRealisasi) }</td>
                    <td class="text-right">${ this.formatNum(totals?.SalesRealisasiPercentage) }</td>
                    <td class="text-right">${ this.formatNum(totals?.SPD) }</td>

                    <td class="text-right">${ this.formatNum(totals?.FSCogs) }</td>
                    <td class="text-right">${ this.formatNum(totals?.Cogs) }</td>
                    <td class="text-right">${ this.formatNum(totals?.CogsRealisasiPercentage) }</td>

                    <td class="text-right">${ this.formatNum(totals?.FSGM) }</td>
                    <td class="text-right">${ this.formatNum(totals?.GrossProfitRealisasi) }</td>
                    <td class="text-right">${ this.formatNum(totals?.GrossProfitRealisasiPercentage) }</td>

                    <td class="text-right">${ this.formatNum(totals?.FSOpex) }</td>
                    <td class="text-right">${ this.formatNum(totals?.OpexRealisasi) }</td>
                    <td class="text-right">${ this.formatNum(totals?.OpexRealisasiPercentage) }</td>

                    <td class="text-right">${ this.formatNum(totals?.FSDepresiasi) }</td>
                    <td class="text-right">${ this.formatNum(totals?.DepresiasiRealisasi) }</td>
                    <td class="text-right">${ this.formatNum(totals?.DepresiasiRealisasiPercentage) }</td>

                    <td class="text-right">${ this.formatNum(totals?.FSEAT) }</td>
                    <td class="text-right">${ this.formatNum(totals?.EatRealisasi) }</td>
                    <td class="text-right">${ this.formatNum(totals?.EatRealisasiPercentage) }</td>

                </tr>
        `;

        htmlContent += `
                </tfoot>
            </table>
          </body>
          </html>
        `;
    
        this.downloadFile(htmlContent, filename+'.xls');
      }
  
    //download file
    downloadFile(content, filename) {
        const blob = new Blob([content], { type: 'application/vnd.ms-excel;charset=utf-8;' });
        const link = document.createElement('a');
        const url = URL.createObjectURL(blob);
        link.setAttribute('href', url);
        link.setAttribute('download', filename);
        link.style.visibility = 'hidden';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }
  }
  